
import * as Yup from "yup";

export const validationSchemaCartComment = Yup.object().shape({
  comment: Yup.string().nullable()
    .required("Comment is required")
    .max(200, "Enter less than 200 characters"),
});

const requiredIfNotDraft = (schema, message, isDraft) =>
  isDraft ? schema.notRequired() : schema.required(message);

export const CarTManufacturingFormSchema = (isDraft = false) =>
  Yup.object().shape({

    leukapheresis_condition: requiredIfNotDraft(
      Yup.number()
        .nullable(),
      "Leukapheresis condition is required",
      isDraft
    ),

    cd3_t_cells_in_leukapheresis: requiredIfNotDraft(
      Yup.number()
        .nullable(),
      "CD3+ T cells in leukapheresis is required",
      isDraft
    ),
    cd3_cells_taken_for_manufacturing: requiredIfNotDraft(
      Yup.number()
        .nullable(),
      "CD3+ T cells in manufacturing is required",
      isDraft
    ),
    cd3_t_cells_after_md: requiredIfNotDraft(
      Yup.number()
        .nullable(),
      "CD3+ T cells after MD is required",
      isDraft
    ),

    cd3_t_cells_for_selection: requiredIfNotDraft(
      Yup.number()
        .nullable(),
      "CD3+ T cells for selection is required",
      isDraft
    ),

    cd3_t_cells_after_selection: requiredIfNotDraft(
      Yup.number()
        .nullable(),
      "CD3+ T cells after selection is required",
      isDraft
    ),

batch_number_lv_used: requiredIfNotDraft(
  Yup.string()
    .nullable()
    .matches(
      /^[A-Za-z0-9,\s]+$/, // Allow legacy commas and new space-separated values
      'Batch number can only contain letters and numbers'
    )
    .test(
      'contains-both',
      'Batch number must contain at least one letter and one number',
      (value) => {
        if (isDraft && (!value || value.trim() === '')) {
          return true; // Allow empty in draft mode
        }
        
        // Non-draft: must exist
        if (!isDraft && (!value || value.trim() === '')) {
          return false;
        }

        // const strValue = String(value)
        const strValue = String(value ?? "")
           .split(/[,\s]+/)
          .map((s) => s.trim())
          .filter((s) => s.length > 0);
        // Check if contains at least one letter AND at least one number
            return strValue.every((strValues) => {
        const hasLetter = /[A-Za-z]/.test(strValues);
        const hasNumber = /[0-9]/.test(strValues);
        
        return hasLetter && hasNumber;
            })
      }
    ),
  "Batch number is required",
  isDraft
),

    no_cell_transduced: requiredIfNotDraft(
      Yup.number().nullable(),
      "No. of cells transduced is required",
      isDraft
    ),

    moi: requiredIfNotDraft(
      Yup.number().nullable()
        .typeError("MOI must be a number")
        .min(2, "MOI must be at least 2")
        .max(8, "MOI must not exceed 8"),
      "MOI is required",
      isDraft
    ),
    activated_cd3_t_cells: requiredIfNotDraft(
      Yup.number()
        .nullable()
        .typeError("Activated CD3+ T cells must be a number"),
      "Activated CD3+ T cells is required",
      isDraft
    ),
    cell_count: Yup.array().of(
      Yup.object().shape({
        day: Yup.string().nullable().notRequired(),
        mfg: Yup.number()
          .nullable()
          .notRequired(),
        qc: Yup.number()
          .nullable()
          .notRequired(),
        te: Yup.number()
          .nullable()
          .notRequired(),
      })
    ),

    te_at_harvest: Yup.number()
      .nullable()
      .notRequired(),

    total_t_cells_harvested: Yup.number()
      .nullable()
      .notRequired(),

    total_t_cells_given_to_qc: Yup.number()
      .nullable()
      .notRequired(),

    total_car_t_cells_filled: Yup.number()
      .nullable()
      .notRequired(),

    car_t_dose_per_kg: Yup.number()
      .nullable()
      .notRequired(),
    // date_of_harvest: Yup.string()
    //   .required("Day of Harvest is required"),
    remarks: requiredIfNotDraft(
      Yup.string().nullable().max(200, "Remarks cannot exceed 200 characters"),
      "Remarks are required",
      isDraft
    ),
  });


export const cartInitialValues = {
  leukapheresis_condition: '',
  cd3_t_cells_in_leukapheresis: '',
  cd3_cells_taken_for_manufacturing:'',
  cd3_t_cells_after_md: '',
  cd3_t_cells_for_selection: '',
  cd3_t_cells_after_selection: '',
  te_at_harvest: '',
  total_t_cells_harvested: '',
  total_t_cells_given_to_qc: '',
  total_car_t_cells_filled: '',
  car_t_dose_per_kg: '',
  batch_number_lv_used: '',
  no_cell_transduced:'',
  moi:'',
  mfg_cell:'',
  qc_cell:'',
  te_cell:'',
  date_of_harvest:'',
  cell_count:[],
  additional_day: [{ day: "" }],
  remarks: "",
  remarks_lead: "",
}
